// ── External URL safety (security audit ING-01) ──────────────────────────────
//
// Job URLs come from untrusted sources (job boards, SerpAPI apply links, the extension capture).
// They are opened with window.open / rendered as <a href> for every candidate who sees the job,
// so a `javascript:` / `data:` / `vbscript:` URL is a stored XSS against other users (the auth
// token lives in localStorage). Only absolute http(s) URLs with a host are ever stored or opened.
export function isSafeHttpUrl(raw) {
    if (typeof raw !== "string")
        return false;
    const s = raw.trim();
    if (!s || s.length > 2048)
        return false;
    // control characters / whitespace inside a URL are never legitimate and are how scheme filters are dodged
    if (/[\u0000-\u001f\u007f\s]/.test(s))
        return false;
    let u;
    try {
        u = new URL(s);
    }
    catch {
        return false;
    }
    if (u.protocol !== "https:" && u.protocol !== "http:")
        return false;
    if (!u.hostname)
        return false;
    if (u.username || u.password)
        return false; // https://trusted.com@evil.example
    return true;
}
//# sourceMappingURL=safe-url.js.map